// src/components/BottomMobileNav.js - Updated with Help System integration
import React, { useState } from 'react';
import { 
  User, Link as LinkIcon, Image, Palette, Layout, 
  Ghost, Settings, ChevronUp, HelpCircle,
  Link2, CreditCard, AlertTriangle, LogOut, UserMinus
} from 'lucide-react';
import styles from './BottomMobileNav.module.css';
// Import the ProFeatureContext
import { useProFeature } from '../context/ProFeatureContext';

const BottomMobileNav = ({
  activeSection,
  setActiveSection,
  isProUser,
  handleProFeatureClick,
  handleSignOut,
  openHelp // New prop for opening help
}) => {
  // Add this line to access the ProFeatureContext
  const { showProFeatureNotification } = useProFeature();
  
  const [linksExpanded, setLinksExpanded] = useState(false);
  const [settingsExpanded, setSettingsExpanded] = useState(false);
  
  // Handle Ghost mode click (Pro feature)
  const handleGhostClick = () => {
    if (!isProUser) {
      // Show prominent notification for pro feature
      showProFeatureNotification('Upgrade to Pro to access Ghost Mode');
      handleProFeatureClick();
    }
    setActiveSection('ghost');
  };
  
  // Toggle links dropdown
  const toggleLinks = () => {
    setLinksExpanded(!linksExpanded);
    // Close settings dropdown if open
    if (settingsExpanded) setSettingsExpanded(false);
  };
  
  // Toggle settings dropdown
  const toggleSettings = () => {
    setSettingsExpanded(!settingsExpanded);
    // Close links dropdown if open
    if (linksExpanded) setLinksExpanded(false);
  };
  
  // Handle section selection and close any open dropdowns
  const selectSection = (section) => {
    setActiveSection(section);
    setLinksExpanded(false);
    setSettingsExpanded(false);
  };

  // Handle shortener click (Pro feature)
  const handleShortenerClick = () => {
    if (!isProUser) {
      // Show prominent notification for pro feature
      showProFeatureNotification('Upgrade to Pro to access Link Shortener');
      handleProFeatureClick();
    }
    setActiveSection('shortener');
  };
  
  // Handle help click and close dropdowns
  const handleHelpClick = () => {
    if (openHelp) {
      openHelp();
    }
    setLinksExpanded(false);
    setSettingsExpanded(false);
  };

  return (
    <div className={styles.bottomNavContainer}>
      {/* Main Bottom Navigation */}
      <nav className={styles.bottomNav}>
        <button 
          className={`${styles.navItem} ${activeSection === 'details' ? styles.active : ''}`}
          onClick={() => selectSection('details')}
        >
          <User size={22} />
          <span>Details</span>
        </button>
        
        <button 
          className={`${styles.navItem} ${(activeSection === 'links' || activeSection === 'shortener') ? styles.active : ''}`}
          onClick={toggleLinks}
        >
          <LinkIcon size={22} />
          <span>Links</span>
          {linksExpanded && <ChevronUp size={12} className={styles.dropupIcon} />}
        </button>
        
        <button 
          className={`${styles.navItem} ${activeSection === 'icons' ? styles.active : ''}`}
          onClick={() => selectSection('icons')}
        >
          <Image size={22} />
          <span>Icons</span>
        </button>
        
        <button 
          className={`${styles.navItem} ${activeSection === 'palette' ? styles.active : ''}`}
          onClick={() => selectSection('palette')}
        >
          <Palette size={22} />
          <span>Palette</span>
        </button>
        
        <button 
          className={`${styles.navItem} ${activeSection === 'theme' ? styles.active : ''}`}
          onClick={() => selectSection('theme')}
        >
          <Layout size={22} />
          <span>Theme</span>
        </button>
        
        <button 
          className={`${styles.navItem} ${activeSection === 'ghost' ? styles.active : ''}`}
          onClick={handleGhostClick}
        >
          <Ghost size={22} />
          <span>Ghost</span>
        </button>
        
        <button 
          className={`${styles.navItem} ${(activeSection === 'subscription' || activeSection === 'reportProblem' || activeSection === 'cancelAccount') ? styles.active : ''}`}
          onClick={toggleSettings}
        >
          <Settings size={22} />
          <span>Settings</span>
          {settingsExpanded && <ChevronUp size={12} className={styles.dropupIcon} />}
        </button>
      </nav>
      
      {/* Links Dropdown */}
      {linksExpanded && (
        <div className={styles.dropupMenu}>
          <button 
            className={styles.dropupItem}
            onClick={() => selectSection('links')}
          >
            <LinkIcon size={18} />
            <span>Manage Links</span>
          </button>
          <button 
            className={styles.dropupItem}
            onClick={handleShortenerClick}
          >
            <Link2 size={18} />
            <span>Link Shortener</span>
          </button>
        </div>
      )}
      
      {/* Settings Dropdown */}
      {settingsExpanded && (
        <div className={styles.dropupMenu}>
          <button 
            className={styles.dropupItem}
            onClick={handleHelpClick}
          >
            <HelpCircle size={18} />
            <span>Help & Tips</span>
          </button>
          <button 
            className={styles.dropupItem}
            onClick={() => selectSection('subscription')}
          >
            <CreditCard size={18} />
            <span>Subscription</span>
          </button>
          <button 
            className={styles.dropupItem}
            onClick={() => selectSection('cancelAccount')}
          >
            <UserMinus size={18} />
            <span>Manage Account</span>
          </button>
          <button 
            className={styles.dropupItem}
            onClick={() => selectSection('reportProblem')}
          >
            <AlertTriangle size={18} />
            <span>Report Problem</span>
          </button>
          <button 
            className={`${styles.dropupItem} ${styles.signOut}`}
            onClick={handleSignOut}
          >
            <LogOut size={18} />
            <span>Sign Out</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default BottomMobileNav;